import { createSelector } from 'reselect';
import { getIsLoading } from '@gameday/utils/selectors/getIsLoading';
import { getLanguage } from '@gameday/utils/selectors/getLanguage';

const getGameState = (state) => {
    const status = state?.gumbo?.gameData?.status || {};
    const { abstractGameState = '', statusCode } = status;
    // If we're in game over state, stay live
    //
    // Not sure we actually want this yet - have to check with Jeff
    // if (abstractGameState === 'Final' && statusCode === 'O') {
    // abstractGameState = 'Live';
    // }
    return abstractGameState;
};

const getShowFieldVision = (state) => {
    const {
        config: {
            enableFieldVision,
            forceFieldVisionOn
        },
        views: {
            fieldVisionOn = false
        } = {},
        loggedIn: {
            isLoggedIn
        } = {}
    } = state;

    return (enableFieldVision || forceFieldVisionOn) && fieldVisionOn && isLoggedIn;
};

const getGameView = (state) => {
    const {
        views: {
            game_view
        } = {}
    } = state;

    return game_view;
};

const getGameTab = (state) => {
    const {
        views: {
            game_tab
        } = {}
    } = state;

    return game_tab;
};

export const getGameStatus = createSelector(
    [getGameState, getShowFieldVision, getIsLoading, getLanguage, getGameView, getGameTab],
    (gameState, showFieldVision, isLoading, language, game_view, game_tab) => {
        return {
            showFieldVision,
            gameState,
            isLoading,
            language,
            game_view,
            game_tab
        };
    }
);
